export const experience = [
    { from: "22-Oct-2021", to: "16-Jun-2023", company: "LTIMindtree" },
    { from: "11-Sep-2023", to: "29-Dec-2023", company: "Eliteware Solutions" },
];

export const totalExperience = experience.reduce((total, currentValue) => {
    const { from, to } = currentValue;
    return total + ((to ? (new Date(to)) : (new Date(new Date().toDateString()))) - new Date(from));
}, 0);
export const getExperience=(totalExperience)=>{
    const totalDays = Math.floor((((new Date(totalExperience).getTime() / 1000) / 60) / 60) / 24);
    const years = Math.floor(totalDays / 360);
    const months = Math.floor((totalDays % 360) / 30);
    const days = (totalDays % 360) % 30;
    return {years,months,days};
};

export const experienceText='EXPERIENCE';
